import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table/table";

class MatchDaysTable extends Component {
  columns = [
    {
      key: "edit",
      className: "col-1",
      content: matchDay => (
        <Link to={`/matchdays/${matchDay.id}`} className="btn btn-info btn-sm">
          <i className="fa fa-edit" />
        </Link>
      )
    },
    {
      key: "delete",
      className: "col-1",
      content: matchDay => (
        <button
          onClick={() => this.props.onDelete(matchDay)}
          className="btn btn-danger btn-sm"
        >
          <i className="fa fa-trash" />
        </button>
      )
    },
    { key: "name", label: "Name", className: "col-10" }
  ];

  render() {
    const { matchDays, onSort, sortColumn } = this.props;

    return (
      <div className="container">
        <Table
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={matchDays}
        />
      </div>
    );
  }
}

export default MatchDaysTable;



// WEBPACK FOOTER //
// ./src/components/matchDays/matchDaysTable.jsx